import { useQuery } from '@apollo/client';
import { GET_USER_LOCATION_ALL } from '@frontend/data-access';
import { Card, Spin, Table } from 'antd';
import dynamic from 'next/dynamic';
import useTranslation from 'next-translate/useTranslation';
import { Suspense, useMemo } from 'react';

const WorldMapDynamic = dynamic(() => import('../DashboardGraphs/WorldMap'), {
  ssr: false,
});

const UsersByCountry = () => {
  const { t } = useTranslation('admin');

  const { data, loading } = useQuery<{
    userCountryRatioAll: {
      count: number;
      all: number;
      country: string;
    }[];
  }>(GET_USER_LOCATION_ALL);

  const columns = useMemo(
    () => [
      {
        title: t('country'),
        dataIndex: 'country',
        key: 'country',
      },
      {
        title: t('users'),
        dataIndex: 'all',
        key: 'all',
      },
    ],
    [t]
  );

  const stats = useMemo(() => {
    return (
      data?.userCountryRatioAll
        ?.filter((item) => item.country)
        .map((item) => ({
          country: item.country,
          count: item.all,
        }))
        .sort((a, b) => b.count - a.count) || []
    );
  }, [data]);

  return (
    <Card
      style={{
        borderRadius: 20,
      }}
    >
      <div className="space-y-4">
        <div className="flex justify-between">
          <div className="text-sm text-gray-900 font-medium">
            {t('users_by_country')}
          </div>
        </div>
        <Suspense fallback={<div>Loading...</div>}>
          {loading ? (
            <Spin />
          ) : (
            <WorldMapDynamic loading={loading} stats={stats} />
          )}
        </Suspense>
        <Table
          size="small"
          rowKey="country"
          dataSource={data?.userCountryRatioAll || []}
          columns={columns}
          pagination={false}
        />
      </div>
    </Card>
  );
};

export default UsersByCountry;
